import { AlertFilled } from "@ant-design/icons";
import React, { FC } from "react";
import { NotificationBadge, NotificationBadgeProps } from "./notification-badge";

export const AlertBell: FC<NotificationBadgeProps> = (props) => {
  return (
    <NotificationBadge
      {...props}
      icon={<AlertFilled style={{ color: props.count > 0 ? "red" : "white" }} />}
    ></NotificationBadge>
  );
};
